import React, { useMemo } from 'react';
import { GroupBase } from 'react-select';
import { ISelectOptionProps, IOptionBase } from '../../models';
import { SelectOption } from '../SelectOption';
import { getExtraStyles } from '@src/atoms/Select/utils';

export type ISelectProps<O extends IOptionBase, M extends boolean, G extends GroupBase<O>> = React.PropsWithChildren<
  ISelectOptionProps<O, M, G>
>;

/** Опция для дефолтного использования в селекте */
export const SelectDefaultOption = <
  OptionType extends IOptionBase,
  GroupType extends GroupBase<OptionType>,
  IsMulti extends boolean,
>(
  props: ISelectProps<OptionType, IsMulti, GroupType>,
) => {
  const { children, innerProps, isFocused, innerRef, data, selectProps } = props;
  const { storage, onChange, getOptionLabel, getOptionValue, optionImageSize, styles } = selectProps;
  const extraStyles = useMemo(() => getExtraStyles(styles?.option), [styles?.option]);

  return (
    <div ref={innerRef} {...innerProps} style={extraStyles}>
      <SelectOption
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectId={selectProps['data-id']!}
        data={data}
        isFocused={isFocused}
        content={children}
        storage={storage}
        classNamePrefix={selectProps.classNamePrefix}
        values={props.getValue() as unknown as IOptionBase[]}
        onChange={onChange}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        setMenuMaxWidth={selectProps.setMenuMaxWidth}
        imageSize={optionImageSize}
      />
    </div>
  );
};
